import React from 'react';

import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import { Decoration_Type } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { BoldDecoration, NodeViewDecorator } from './../../ricos-types/index.js';

const decorator = (boldDecoration: BoldDecoration, element?: JSX.Element) => {
  const { fontWeightValue } = boldDecoration;
  return (
    <strong key={`bold-${element?.key}`} style={{ fontWeight: fontWeightValue || 700 }}>
      {element}
    </strong>
  );
};

const BoldDecorator: NodeViewDecorator<JSX.Element> = {
  rule: (node: Node) =>
    !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.BOLD),
  decorate: ({ element, node }) => {
    const boldDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.BOLD
    ) as BoldDecoration;
    return decorator(boldDecoration, element);
  },
};

export default BoldDecorator;
